function Breaker() {
  return <div className="mx-auto w-3/4 bg-gradient-to-r from-gray-200 to-transparent my-8 h-0.5"></div>
}

export default Breaker;